import { AvailableAddressOutSchema } from "@/api/client";
import { PINIA_PERSIST_OPTIONS } from "@/helpers/constants";
import { SubscriptionPlan } from "@/helpers/types/numberProvision";
import { PhoneNumberDetails } from "@/helpers/types/numbers";
import { defineStore } from "pinia";
import { CountryItem, InternationalPlan } from "../types";

interface NumberAddressAddOnState {
  countryCode: string;
  country: string;
  numberRegion: string;
  selectedPeriod: string;
  addresses: unknown[];
  stateCode: string;
  pageSize: number;
  internationalPlans: InternationalPlan[] | null | undefined;
  selectedNumber: PhoneNumberDetails | null | undefined;
  selectedAddress: AvailableAddressOutSchema | null | undefined;
  allPlans: unknown;
  allPlansCountries: unknown;
  selectedPlan:
    | InternationalPlan
    | SubscriptionPlan
    | string
    | null
    | undefined;
  formDetails: {
    dialCode: string;
    phoneNumber: string;
    firstName: string;
    lastName: string;
    email: string;
    businessName: string;
  };
  selectedCountry: CountryItem;
}

export const useNumberAddressAddOnStore = defineStore("number-address-addon", {
  state: (): NumberAddressAddOnState => ({
    countryCode: "US",
    country: "United States",
    numberRegion: "US",
    selectedPeriod: "monthly",
    addresses: [],
    stateCode: "",
    pageSize: 100,
    internationalPlans: null,
    selectedNumber: null,
    selectedAddress: null,
    selectedPlan: null,
    allPlansCountries: [],
    allPlans: null,
    formDetails: {
      dialCode: "+234",
      lastName: "",
      firstName: "",
      businessName: "",
      email: "",
      phoneNumber: "",
    },
    selectedCountry: {
      flag: "fi-us",
      country: "United States of America",
      countryCode: "US",
      dialCode: "+1",
    },
  }),
  actions: {
    resetStore() {
      this.$reset();
    },
  },
  persist: PINIA_PERSIST_OPTIONS,
});
